import { useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import _ from 'lodash'
import { withLocalize } from 'react-localize-redux'

import { Modal } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'

import styles from './EditGroupContainer.module.scss'
import { showSnackbar } from 'common/actions/snackbar'
import { createGroup } from 'common/actions/systems'
import EditGroupForm from '../components/EditGroupForm/EditGroupForm'
import { getError, getIsSubmitting } from '../selectors'

const EditGroupContainer = props => {
  const [open] = useState(true)
  const { hideModal, group, createGroup, systems } = props
  const systemsGroup = _.groupBy(systems, 'group')

  const handleSubmit = d => {
    const devicesIds = d.deviceIds || []
    // Si ha cambiado el nombre del grupo, añadimos también los pertenecientes al grupo para ser actualizados
    if (d.group !== group) {
      for (let i = 0; i < systemsGroup[group].length; i++) {
        devicesIds.push(systemsGroup[group][i]._id)
      }
    }
    const data = {
      group: d.group,
      deviceIds: devicesIds,
      noGroupDeviceIds: d.noGroupDeviceIds || []
    }
    createGroup(data)
  }

  const StyledPaper = withStyles({
    root: {
      maxHeight: '100% !important',
      'overflow-y': 'visible',
      fontFamily: 'Roboto',
      verticalAlign: 'top',
      maxWidth: '500px'
    }
  })

  return (
    <Modal
      open={open}
      onClose={hideModal}
      arial-labelledby='simple-modal-title'
      arial-desccribedby='simple-modal-description'
      BackdropProps={{
        classes: {
          root: styles.backdrop
        }
      }}
      PaperComponent={StyledPaper}
    >
      <div className={styles.content}>
        <EditGroupForm
          {...props}
          editingGroup={group}
          allSystems={Object.freeze(_.cloneDeep(systems))} // Clone to prevent mutation
          onSubmit={handleSubmit}
          onCancel={hideModal}
        />
      </div>
    </Modal>
  )
}

EditGroupContainer.propTypes = {
  submitError: PropTypes.any,
  hideModal: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
  submitError: getError(state),
  isSubmitting: getIsSubmitting(state)
})

const mapActionsToProps = {
  createGroup,
  showSnackbar
}

export default withLocalize(connect(mapStateToProps, mapActionsToProps)(EditGroupContainer))
